export default __webpack_public_path__ + "static/Espacos-planejados-8ccb995044c217ef7d2714a1e93eadc8.jpg";